export const showEtchingConfirmationModal = ({ showGenericConfirm, callback }) => {
    showGenericConfirm({
        title: this.$t('COLORS_ARE_YOU_SURE_ETCHING'),
        description: this.$t('COLORS_CUSTOMIZATIONS_WILL_BE_LOST'),
        cancelAction: this.$t('COLORS_STAY_FULL_COLOR'),
        confirmAction: this.$t('COLORS_CONFIRM_ETCHING'),
        confirmationCallback: () => {
            callback();
        },
    });
};

export const showPrintingConfirmationModal = ({ showGenericConfirm, callback }) => {
    showGenericConfirm({
        title: this.$t('COLORS_ARE_YOU_SURE_FULL_COLOR'),
        description: this.$t('COLORS_CUSTOMIZATIONS_WILL_BE_LOST'),
        cancelAction: this.$t('COLORS_STAY_ETCHING'),
        confirmAction: this.$t('COLORS_CONFIRM_FULL_COLOR'),
        confirmationCallback: () => {
            callback();
        },
    });
};

export const showQuantityWarningConfirmationModal = ({ showGenericConfirm, callback, colorway }) => {
    showGenericConfirm({
        title: this.$t('QUANTITY_WARNING', {
            ats: colorway.ats,
            items: colorway.ats > 1 ? this.$t('QUANTITY_ITEMS') : this.$t('QUANTITY_ITEM'),
        }),
        description: this.$t('QUANTITY_WARNING_BODY'),
        cancelAction: this.$t('ACTION_CANCEL'),
        confirmAction: this.$t('ACTION_CONTINUE'),
        confirmationCallback: () => {
            callback();
        },
    });
};
